<template>
  <nav id="pagination" aria-label="...">
    <ul class="pagination">
        <li class="page-item disabled">
          <a class="page-link" href="#" tabindex="-1">Vorige</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">1</a>
        </li>
        <li class="page-item active">
          <a class="page-link" href="#">2 <span class="sr-only">(current)</span></a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">3</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">Volgende</a>
        </li>
    </ul>
</nav>
</template>

<script>
export default {
  name: 'pagination',
  props:{
    pages:{
      type: Array
    },
    current:{
      type: String
    },
  },
  data(){
    return{
    }
  }
}
</script> 

<style scoped>
    
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/pagination.vue